export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/FinanceLogo.f5ba3d67.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};